module.exports = __webpack_public_path__ + "assets/img/1_1490.2b38cefc.jpg";